@if (selectedType()) {
  <h3>{{ 'report.apartmentRound.list.' + selectedType().name | translate }}</h3>
  <h4>{{ 'report.apartmentRound.date' | translate }}</h4>
  <app-select-day [id]="'reportDate'"
    [color]="'light'"
    [name]="'calendar.title'"
    [value]="report().date"
    (changed)="onDateChange($event)"></app-select-day>
  <h4>{{ 'home.renovation.participants' | translate }}</h4>
  @for (item of users(); track $index) {
    <ion-item lines="none">
      <ion-checkbox (ionChange)="onUser($event, item)">{{ item.name }}</ion-checkbox>
    </ion-item>
  }
  <div class="ion-margin-top ion-margin-bottom">
    <ion-button color="light"
      (click)="addUser()">
      {{ 'report.apartmentRound.addUser' | translate }}
    </ion-button>
  </div>
  @for (item of report().participants; track $index; let i = $index) {
    <ion-item lines="none">
      {{ item.name }}
      <ion-button slot="end"
        color="danger"
        (click)="onRemoveUser(i)">
        <ion-icon slot="icon-only"
          name="trash-outline"></ion-icon>
      </ion-button>
    </ion-item>
  } @empty {
    <p>{{ 'report.apartmentRound.noParticipants' | translate }}</p>
  }
  <ion-item lines="none">
    <ion-textarea autocapitalize="on"
      [(ngModel)]="report().summary"
      rows="5"
      [placeholder]="'report.apartmentRound.summary' | translate">
    </ion-textarea>
    <app-speech-to-text (text)="onMic($event, 'summary')"></app-speech-to-text>
  </ion-item>
  @if (areas$ | async; as areas) {
    <ion-button color="light"
      (click)="addArea(areas)">
      {{ 'room.addArea' | translate }}
    </ion-button>
  }
  @for (area of report().areas; track $index; let i = $index) {
    <div class="area">
      <ion-item>
        {{ area.name }}
        <ion-button slot="end"
          color="danger"
          (click)="onRemoveArea(i)">
          <ion-icon slot="icon-only"
            name="trash-outline"></ion-icon>
        </ion-button>
      </ion-item>
      @for (item of selectedType().items; track $index) {
        <h4>{{ 'report.apartmentRound.items.' + item | translate }}</h4>
        <ion-item lines="none">
          <ion-input autocapitalize="on"
            [(ngModel)]="area.type[item].blocked"
            [placeholder]="'report.apartmentRound.blocked' | translate">
          </ion-input>
          <app-speech-to-text (text)="onMic($event, 'blocked', i, item)"></app-speech-to-text>
        </ion-item>
        <ion-button color="primary"
          (click)="addRoom(item, area)">
          {{ 'room.addCommonButton' | translate }}
        </ion-button>
        @for (room of area.type[item].rooms; track $index) {
          <ion-item lines="none">
            <ion-input autocapitalize="on"
              [(ngModel)]="room.name"
              [placeholder]="'report.apartmentRound.area' | translate">
            </ion-input>

          </ion-item>
          <ion-item lines="none">
            <ion-input autocapitalize="on"
              [(ngModel)]="room.extras"
              [placeholder]="'report.apartmentRound.areaExtras' | translate">
            </ion-input>

          </ion-item>
          <ion-item lines="none">
            <ion-input autocapitalize="on"
              [(ngModel)]="room.condition"
              [placeholder]="'report.apartmentRound.condition' | translate">
            </ion-input>

          </ion-item>
          <ion-item lines="none">
            <ion-input autocapitalize="on"
              [(ngModel)]="room.conditionExtras"
              [placeholder]="'report.apartmentRound.conditionExtras' | translate">
            </ion-input>

          </ion-item>
          <h4>{{ 'home.renovation.review.images' | translate }}</h4>
          <app-images [showCamera]="'item.addImage'"
            [images]="room.images"
            [canDelete]="true"
            (openCamera)="onImage(room, $event)"
            (deleted)="onDeleteImage(room, $event)"></app-images>
        }
      }
    </div>
  }
} @else {
  @for (item of types; track $index) {
    <ion-item button="true"
      lines="none"
      (click)="selectType(item)">
      <div>
        {{ 'report.apartmentRound.list.' + item.name | translate }}<br />
        <ion-note>
          {{ 'report.apartmentRound.list.' + item.name + 'Sub' | translate }}
        </ion-note>
      </div>
    </ion-item>
  }
}